"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.externalBrand = void 0;
var externalBrand = {
  facebook: '#4267B2',
  twitter: '#31AEF4'
};
exports.externalBrand = externalBrand;
//# sourceMappingURL=externalBrand.js.map